import { useCallback } from 'react';
import { useAtom } from 'jotai';
import tw from 'twin.macro';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { CreditCardIcon } from '@heroicons/react/24/outline';

import { BaseModal, ButtonV2, Title } from '@restworld/ui-ds';
import { useAuth } from '@restworld/feature-authentication';

import { isUnpaidInvoicesModalOpenAtom } from '../atoms/unpaid-invoices-modal.atoms';

function UnpaidInvoicesModal() {
  const { t } = useTranslation('jp-onboarding');
  const router = useRouter();
  const { user } = useAuth();
  const [isUnpaidInvoicesModalOpen, setIsUnpaidInvoicesModalOpen] = useAtom(isUnpaidInvoicesModalOpenAtom);

  const handleClose = useCallback(() => {
    setIsUnpaidInvoicesModalOpen(false);
  }, [setIsUnpaidInvoicesModalOpen]);

  const handleGoToPayments = useCallback(() => {
    router.push('/employer/payments-and-invoices');
    handleClose();
  }, [router, handleClose]);

  // Get user's first name for personalization
  const userName = user?.name || 'User';

  return (
    <BaseModal
      open={isUnpaidInvoicesModalOpen}
      onClose={handleClose}
      modalStyles={[tw`md:(w-full max-w-[640px])`]}
      title={
        <div tw="px-10 text-center">
          <Title
            content={t('unpaid_invoices_modal.title', { name: userName })}
            textColor="black"
            fontWeight="semibold"
            fontSize="large"
          />
        </div>
      }
      footer={
        <div tw="flex justify-center w-full">
          <ButtonV2 onClick={handleGoToPayments} StartIcon={CreditCardIcon} tw="w-full">
            {t('unpaid_invoices_modal.cta')}
          </ButtonV2>
        </div>
      }
    >
      <div tw="text-center font-medium text-base text-neutral-90 leading-normal px-10 pb-10">
        {t('unpaid_invoices_modal.description')}
      </div>
    </BaseModal>
  );
}

export default UnpaidInvoicesModal;
